module.exports = __webpack_public_path__ + "static/img/pinpai-26.1ab267e3.png";